import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useModal } from "../../_contexts";
import { Button, Icon, PaneLoader } from "../../_components";
import { useEventListener } from "../../_hooks";
import {
  MarkerActions,
  TimelineActions,
  ImageActions,
  EventActions,
  MarkerTemplatesActions,
  MapActions,
} from "../../_actions";

export function ConfirmDeletionForm({ type, item, prev, text }) {
  // console.log("Delete cofirmation form props:", type, item, prev, text);
  const { closeModal, openModal } = useModal();
  const [isLoading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const handleCloseModal = () => {
    if (prev && prev.length > 0) {
      openModal(prev);
    } else {
      closeModal();
    }
  };

  const handleSubmit = (e) => {
    setLoading(true);
    e.preventDefault();
    switch (type) {
      case "map":
        dispatch(MapActions.deleteMapById(item._id))
          .then(() => {
            setLoading(false);
          })
          .then(() => {
            handleCloseModal();
          });
        break;
      case "marker":
        dispatch(MarkerActions.deleteMarker(item._id))
          .then(() => {
            setLoading(false);
          })
          .then(() => {
            handleCloseModal();
          });
        // console.log('DELETING');
        // if (prev && prev.length > 0) openModal(prev);
        break;
      case "timeline":
        dispatch(TimelineActions.deleteTimeline(item._id))
          .then(() => {
            setLoading(false);
          })
          .then(() => {
            handleCloseModal();
          });
        break;
      case "imageSingle":
        dispatch(ImageActions.deleteImage(item._id))
          .then(() => {
            setLoading(false);
          })
          .then(() => {
            handleCloseModal();
          });
        break;
      case "event":
        dispatch(EventActions.deleteEvent(item._id))
          .then(() => {
            setLoading(false);
          })
          .then(() => {
            handleCloseModal();
          });
        break;
      case "eventMultiple":
        dispatch(EventActions.deleteMultiple(item))
          .then(() => {
            setLoading(false);
          })
          .then(() => {
            handleCloseModal();
          });
        break;
      case "imageMultiple":
        const itemIDs = [];
        item.forEach((image) => {
          itemIDs.push(image._id);
        });
        dispatch(ImageActions.deleteMultiple(itemIDs))
          .then(() => {
            setLoading(false);
          })
          .then(() => {
            handleCloseModal();
          });
        break;
      case "markerTemplate":
        dispatch(MarkerTemplatesActions.deleteTemplate(item._id))
          .then(() => {
            setLoading(false);
          })
          .then(() => {
            handleCloseModal();
          });
        break;
    }
  };

  const handleCancel = (e) => {
    setLoading(false);
    if (prev && prev.length > 0) {
      // console.log('Returning to previous modal');
      openModal(prev);
    } else {
      closeModal();
    }
  };

  const handleKeyClose = (ev) => {
    if (ev.key && ev.key.toLowerCase() === "escape") {
      handleCancel();
    }
  };

  useEventListener("keyup", handleKeyClose);

  const isMultiple = Array.isArray(item);

  return (
    <form onSubmit={handleSubmit} className="chronos-form">
      <PaneLoader isLoading={isLoading} />
      {!isMultiple && (
        <p className="warning-text">
          You are about to delete {item?.title || item.name}
        </p>
      )}
      {isMultiple && (
        <p className="warning-text">
          You are about to delete {item.length} items.
        </p>
      )}
      {text && <p className="warning-additional-info">{text}</p>}
      <p>Are you sure?</p>

      <div className="form-controls">
        <Button type="button" color="secondary" onClick={handleCancel}>
          <Icon icon="fas fa-times fa-fw" />
          Cancel
        </Button>
        <Button type="submit" color="danger" onClick={handleSubmit}>
          <Icon icon="fas fa-trash fa-fw" />
          Delete
        </Button>
      </div>
    </form>
  );
}
